import type { PlanType } from '@simplywallst/services/types/endpoints/getUacCheck';

const PLANS_MAP_TO_RANDOM_TEXT = {
  premium: 'b22c115f58f700436e7febf01b9059f8',
  unlimited: '9b5d1ef4978e68284ad5e6b8d2657235',
  advisor: 'fcee21d3cc0dd5eb09cbdad6975fb385',
  free: '8ae7965f362e0cd408c185344c8450fb',
  '': '8fefaa164f51cc963927c57782b51028',
};

export const encryptPlanType = (planType: PlanType) => {
  return PLANS_MAP_TO_RANDOM_TEXT[planType];
};

export const decryptPlanType = (encryptedPlanType: string): PlanType => {
  const supportedPlanTypes = Object.keys(
    PLANS_MAP_TO_RANDOM_TEXT
  ) as PlanType[];

  const planType = supportedPlanTypes.find(
    (type) => PLANS_MAP_TO_RANDOM_TEXT[type] === encryptedPlanType
  );

  return planType || '';
};
